module.exports = __webpack_public_path__ + "img/6.58dc5be7.jpg";